export default __webpack_public_path__ + "static/media/tool-icon-shirt-blue-09.b14d4332.svg";